/* eslint-disable object-curly-newline,no-undef */
import React from 'react';
import {Col, Row} from 'react-bootstrap';
import './ViewOnlyWorkOrder.css';
import {BASE_URL} from "../../../helpers/api/apiPaths";
import S3Item from "../../S3Item/S3Item";

// eslint-disable-next-line react/prefer-stateless-function
export class ViewOnlyWorkOrder extends React.Component {
  componentWillMount() {
  }

  simpleData(name, value, className = "simpleData-name") {
    return (
      <Col sm={12} md={2}>
        <Row>
          <Col sm={12} className={className}>
            {name}
          </Col>
          <Col sm={12}>
            {value}
          </Col>
        </Row>
      </Col>
    )
  }

  fullTextData(name, value) {
    return (<span>
      <Row><Col className="data-subHeading-name">{name}</Col></Row>
      <Row><Col>{value}</Col></Row>
    </span>)
  }

  render() {

    const {workOrder} = this.props;

    return (
      <span>
        {workOrder &&
          <span>
            <Row>
              { this.simpleData("Date", workOrder.wo_date) }
              { this.simpleData("Project", workOrder.project.name) }
              { this.simpleData("Inspector", workOrder.inspector) }
              { this.simpleData("City", workOrder.city) }
              { this.simpleData("State", workOrder.state) }
              { this.simpleData("County", workOrder.county) }
            </Row>
            <Row>
              <Col sm={12} md={6}><Row><Col className="simpleData-name">Work Accomplished</Col><Col>{workOrder.work_accomplished}</Col></Row></Col>
              <Col sm={12} md={6}><Row><Col className="simpleData-name">Notes</Col><Col>{workOrder.notes}</Col></Row></Col>
            </Row>
            <Row><Col className="simpleData-name">Tailgate {workOrder.no_tailgate && "(No Tailgate)"}</Col></Row>
            <div className="data-subHeading">
              {workOrder.tailgate_url
                ?
                <Row>
                  <Col>
                    <S3Item
                      isPdf={workOrder.tailgate_is_pdf}
                      link={`${BASE_URL}/workorders/${workOrder.id}/tailgate`}
                    />
                  </Col>
                </Row>
                :
                <Row>
                  <Col sm={12} md={6}><Row><Col className="data-subHeading-name">Daily Activity</Col><Col>{workOrder.tailgate_daily_activity}</Col></Row></Col>
                  <Col sm={12} md={6}><Row><Col className="data-subHeading-name">Safety Hazards</Col><Col>{workOrder.tailgate_safety_hazards}</Col></Row></Col>
                </Row>
              }
            </div>
            <Row><Col className="simpleData-name">Employees</Col></Row>
            <div className="data-subHeading">
              {workOrder.employee_timesheets.map((e) =>
                (
                  <Row>
                    <Col sm={12} className="data-subGroupHeading">{e.employee.name}</Col>
                    { this.simpleData("Class", e.labor_class.name, "data-subGroupHeading-name") }
                    { this.simpleData("Per Diem", e.per_diem, "data-subGroupHeading-name") }
                    { this.simpleData("Check In", e.checkin, "data-subGroupHeading-name") }
                    { this.simpleData("Check Out", e.checkout, "data-subGroupHeading-name") }
                    { this.simpleData("Hours", e.hours, "data-subGroupHeading-name") }
                    { this.simpleData("Truck/Rig Pay", e.truck_rig, "data-subGroupHeading-name") }
                  </Row>
                ))
              }
            </div>
            <Row><Col className="simpleData-name">Sub Contractors</Col></Row>
            <div className="data-subHeading">
              {workOrder.subcontractor_timesheets.map((e) =>
                (
                  <Row>
                    <Col sm={12} className="data-subGroupHeading">{e.subcontractor.name}</Col>
                    { this.simpleData("Class", e.labor_class.name, "data-subGroupHeading-name") }
                    { this.simpleData("Hours", e.hours, "data-subGroupHeading-name") }
                  </Row>
                ))
              }
            </div>
            <Row><Col className="simpleData-name">Equipment</Col></Row>
            <div className="data-subHeading">
              {workOrder.equipment_timesheets.map((e) =>
                (
                  <Row>
                    <Col sm={12} className="data-subGroupHeading">{e.equipment.name}</Col>
                    { this.simpleData("Hours", e.equipment_hours, "data-subGroupHeading-name") }
                    { this.simpleData("Machine Total Hours", e.subcontractor_hours, "data-subGroupHeading-name") }
                  </Row>
                ))
              }
            </div>
            <Row><Col className="simpleData-name">Materials</Col></Row>
            <div className="data-subHeading">
              {workOrder.materials.map((e) =>
                (
                  <Row>
                    { this.simpleData("Payment Type", e.payment_type.name, "data-subGroupHeading-name") }
                    { this.simpleData("Price", e.price, "data-subGroupHeading-name") }
                    { this.simpleData("Cost Code", e.cost_code.name, "data-subGroupHeading-name") }
                    { this.simpleData("Vendor", e.vendor, "data-subGroupHeading-name") }
                    { this.simpleData("Description", e.no_receipt, "data-subGroupHeading-name") }
                    { this.simpleData("Receipt", <S3Item
                      isPdf={e.receipt_is_pdf}
                      link={`${BASE_URL}/materials/${e.id}/receipt`}
                    />, "data-subGroupHeading-name") }

                  </Row>
                ))
              }
            </div>
          </span>
        }
        <br/>
        <br/>
      </span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/WorkOrder/ViewOnly/ViewOnlyWorkOrder.jsx